import { getActiveExperimentsHeaderTab } from '@/reducers/ui/projectsUiReducer';
import { DashboardViewUpdatePayload } from '@experiment-management-shared/types';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

type UseDashboardActiveExperimentTabOpts = {
  hiddenExperimentKeys?: string[];
  selection?: string[];
  updateDashboardView: (data: DashboardViewUpdatePayload) => void;
};
const useDashboardActiveExperimentTab = ({
  hiddenExperimentKeys = [],
  selection = [],
  updateDashboardView
}: UseDashboardActiveExperimentTabOpts) => {
  const activeExperimentsHeaderTab = useSelector(getActiveExperimentsHeaderTab);

  useEffect(() => {
    updateDashboardView({
      table: { pageNumber: 0 }
    });
  }, [activeExperimentsHeaderTab]);

  const experimentKeysForExperimentsTab = useMemo(() => {
    const experimentsForTab = [null, selection, hiddenExperimentKeys];

    return experimentsForTab[activeExperimentsHeaderTab];
  }, [activeExperimentsHeaderTab, hiddenExperimentKeys, selection]);

  return {
    activeExperimentsHeaderTab,
    experimentKeysForExperimentsTab
  };
};

export default useDashboardActiveExperimentTab;
